import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import TextInput from 'components/TextInput/TextInput';
import React, { useEffect, useMemo, useState } from 'react';
import { getAddressSuggestions } from 'store/location/services/getAddressSuggestions';

function AddressAutocomplete({
  label = 'No label',
  name = 'address',
  disabled = false,
  required,
  value = null, // The value of the input
  onChange = () => {}, // Called when changing input value
  handleSelect = () => {}, // Called when an option is chosen
  ...restProps // Collect all additional props
}) {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!value || (value && value.length < 3)) {
        setSuggestions([]);
        return;
      }

      try {
        const result = await getAddressSuggestions(value);
        setSuggestions(result);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setSuggestions([]);
      }
    };

    fetchSuggestions();
  }, [value]);

  return (
    <Autocomplete
      id="address-autocomplete"
      fullWidth
      getOptionLabel={(option) => {
        if (!option.Label) return option;
        const label = option.Label;
        const firstCommaIndex = label.indexOf(',');
        const streetAddress = label.substring(0, firstCommaIndex).trim();
        return streetAddress;
      }}
      filterOptions={(x) => x}
      options={suggestions}
      value={value}
      name={name}
      disabled={disabled}
      autoComplete
      includeInputInList
      filterSelectedOptions
      noOptionsText="Ei tuloksia"
      freeSolo
      onChange={(event, newValue) => {
        handleSelect(newValue);
      }}
      onInputChange={onChange}
      renderInput={(params) => (
        <TextInput
          {...params}
          {...restProps} // Pass through additional props
          label={label}
          name={name}
          fullWidth
          required={required}
        />
      )}
      renderOption={(option) => {
        const label = option.Label || 'No label';

        // Find the index of the first comma
        const firstCommaIndex = label.indexOf(',');
        // Separate the address into two parts using the index of the first comma
        const streetAddress = label.substring(0, firstCommaIndex).trim();
        const rest = label.substring(firstCommaIndex + 1).trim();

        return (
          <Grid container key={option.key}>
            <Grid item xs>
              <Typography noWrap>{streetAddress}</Typography>
              <Typography noWrap style={{ fontSize: 'small' }}>
                {rest}
              </Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default AddressAutocomplete;
